/* unplugin-vue-components disabled */import { render } from "./UserName.vue?vue&type=template&id=4b243744&scoped=true"
import script from "./UserName.vue?vue&type=script&lang=js"
export * from "./UserName.vue?vue&type=script&lang=js"

import "./UserName.vue?vue&type=style&index=0&id=4b243744&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/zeta-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b243744"]])

export default __exports__